import React from 'react';
import { 
	string, 
	func, 
	object ,
	bool,
	instanceOf
} from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import {findAnswers,} from '../../../logics/questionBuilder';

class Container extends React.PureComponent {
	static propTypes = {
		options:object,
		editText:string,
		render:func.isRequired,
		isSample:bool,
		onHide : func.isRequired,
		quiz : object,
		onSaveNew : func.isRequired,
		onSave : func.isRequired,
		recipeId : string,
		cookies: instanceOf(Cookies).isRequired
	}

	constructor(props) {
		super(props);
		const { quiz = {} } = props;
		const { isSample, options, explanation } = quiz;
		const { cookies } = props;
		const showAnswerOption = cookies.get('showAnswerOption');
		const showExplanation = cookies.get('showExplanation');
		const showHelp = JSON.parse(localStorage.getItem('createQuizModal.showHelp')) || true;
		this.state = {
			options : options || {},
			enableAnswerOption : showAnswerOption && showAnswerOption==='true',
			enableExplanation : showExplanation && showExplanation==='true',
			selectedAnswerIndex:0,
			isSample:Boolean(isSample),
			explanation : explanation || '',
			showHelp
		};
	}

	render(){
		const {editText,render,cookies,onHide,quiz,onSaveNew,recipeId,onSave,editorProps} = this.props;
		const {options,isSample,explanation} = this.state;
		const textArray = editText.split(/\r?\n/g);
		let answers = [];
		for(const text of textArray){
			const result = findAnswers(text);
			if(result.answers){
				answers = answers.concat(result.answers);
			} 
		}
		const previewProps = {
			editText,
			options:this.state.options,
			onClickAnswer:(idx)=>{
				this.setState({selectedAnswerIndex:idx,enableAnswerOption:true});
				cookies.set('showAnswerOption', true);
			}
		};
		const expanderProps = {
			onClickExpand : ()=>{
				this.setState({enableAnswerOption:true});
				cookies.set('showAnswerOption', true);
			},
			onClickClose : ()=>{
				this.setState({enableAnswerOption:false});
				cookies.set('showAnswerOption', false);
			},
			enableAnswerOption : this.state.enableAnswerOption
		};
		let optionProps = null;
		if(answers.length > 0){
			const answer = answers[this.state.selectedAnswerIndex];
			const optionsForAnswer = this.state.options[answer] || {};
			optionProps = {
				key:optionsForAnswer,
				number:this.state.selectedAnswerIndex,
				answer,
				optionsForAnswer,
				onChangeChoice:(newOptions)=>{
					let op = {...this.state.options};
					op[answer]=newOptions;
					this.setState({options:op});
				},
				onNextClicked:()=>{
					if(answers.length>(this.state.selectedAnswerIndex+1))
						this.setState({selectedAnswerIndex:this.state.selectedAnswerIndex+1});
				},
				onBackClicked:()=>{
					if(this.state.selectedAnswerIndex>0)
						this.setState({selectedAnswerIndex:this.state.selectedAnswerIndex-1});
				}
			};
		}
		const toggleShowHelp = (show) => ()=> {
			localStorage.setItem('createQuizModal.showHelp', JSON.stringify(show));
			this.setState({
				showHelp : show
			});
		};
		return render({
			previewProps,
			optionProps,
			expanderProps,
			answers,
			showHelp : this.state.showHelp,
    		toggleShowHelp,
			editorProps : {
				...editorProps,
				onClickHelp : () => {
					toggleShowHelp(!this.state.showHelp)();
				}
			},
			onSubmit : () => {
				if (quiz) {
					onSave(recipeId, quiz.id, {
						question : editText, 
						answers, 
						options, 
						isSample, 
						explanation
					});
				}
				else {
					onSaveNew({
						question : editText, 
						answers, 
						options, 
						isSample, 
						explanation
					});
				}
				onHide();
			},
			options,
			isSample,
			onCheckSample:(checked)=>{
				this.setState({isSample:checked});
			},
			explanation,
			onChangeExplanation : (event) => {
				this.setState({
					explanation: event.target.value,
				});
			}
		});
	}
}

export default withCookies(Container);
